import { useRef, useEffect } from 'react';
import { getViteAppName } from '../utils/Vite/getViteAppName';

const useDocumentTitle = (title: string, remainOnUnmount = false) => {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = `${getViteAppName()} - ${title}`;
  }, [title]);

  useEffect(
    () => () => {
      if (!remainOnUnmount) {
        document.title = defaultTitle.current;
      }
    },
    []
  );
};

export default useDocumentTitle;
